module.exports = __webpack_public_path__ + "ng.svg?f6a23478e72fa37e3b9f3869524e0dfa";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ng.svg
// module id = 1537
// module chunks = 0